/**
 * Public embed for the Valoriza directory — intended to be loaded via iframe
 * from the corporate intranet, without any sidebar or login.
 *
 * URL format: /directory-embed?key=<DIRECTORY_EMBED_KEY>
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Directory from './Directory';
import { ValorizaLogo } from '../components/ValorizaLogo';
import { AlertCircle } from 'lucide-react';

export default function DirectoryEmbed() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Tell the parent (intranet iframe host) we are ready, in case they listen
    if (window.parent && window.parent !== window) {
      try { window.parent.postMessage({ type: 'valoriza-directory-ready' }, '*'); } catch (e) {}
    }
    setReady(true);
  }, []);

  if (!key) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md text-center rounded-2xl border border-destructive/30 bg-destructive/5 p-8" data-testid="embed-no-key">
          <AlertCircle className="h-8 w-8 text-destructive mx-auto mb-3" />
          <h1 className="text-lg font-semibold">Acceso requerido</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Falta la clave de acceso. La URL debe incluir <code className="bg-muted px-1 rounded">?key=&lt;clave&gt;</code>.
          </p>
        </div>
      </div>
    );
  }

  if (!ready) return null;

  return (
    <div className="min-h-screen bg-background">
      {/* Slim header — intentionally minimal so it embeds nicely */}
      <header className="border-b border-border bg-card/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <ValorizaLogo height="h-7" />
          <span className="text-xs text-muted-foreground">Directorio corporativo</span>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <Directory embedKey={key} />
      </main>
    </div>
  );
}
